// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__2iVyD","containerItemsCenter":"Skeleton_containerItemsCenter__sH7q6"};